import styled, { css, ThemeProps } from 'styled-components';
import { Theme } from '../theme';
import { media } from '../theme/base/mixins';
import { StyledHRComponent } from '../types';

interface LineProps {
  footer?: boolean;
}

type LinePropsThemed = ThemeProps<Theme> & LineProps;

export const Line: StyledHRComponent<LineProps> = styled.hr`
  border-color: ${(props: LinePropsThemed) => props.theme.colors.white};
  opacity: 0.8;

  ${(props: LinePropsThemed) =>
    props.footer &&
    css`
      display: none;
    `}

  ${media.large`
    ${(props: LinePropsThemed) =>
      props.footer &&
      css`
        display: block;
        margin-top: 40px;
        margin-bottom: 40px;
      `}
  `}
`;
